<template>
<div>
  <v-stepper v-model="stepper">
    <v-stepper-header>
      <v-divider></v-divider>
      <v-stepper-step :complete="stepper > 1" :editable="stepper > 1" step="1">{{ $t("presentation.presentation") }}</v-stepper-step>
      <v-divider></v-divider>
      <v-stepper-step :complete="images.length > 0" :editable="images.length > 0" step="2">{{ $t("presentation.slaids") }}</v-stepper-step>
      <v-divider></v-divider>
    </v-stepper-header>
    <v-stepper-items id="work-block">

      <v-stepper-content step="1">
        <v-progress-circular indeterminate color="primary" v-if="loading" spacing="pr-4"></v-progress-circular>
        <div v-else>
          <v-card>
            <v-card-title class="headline" primary-title>
              {{ $t('presentation.presentation') }}
            </v-card-title>
            <v-container>
              <div>
                <v-text-field v-model="name" label="Name" required></v-text-field>
                <v-text-field v-model="description" label="Opis"></v-text-field>
                <v-select v-model="type" :items="types" item-value="type" item-text="name" label="Typ"></v-select>
              </div>
            </v-container>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn large color="primary" round @click="nextStep()">{{ $t("base.continue") }}</v-btn>
            </v-card-actions>
          </v-card>
        </div>
      </v-stepper-content>

      <v-stepper-content v-if="this.stepper==2" step="2">

        <div v-if="type == TYPE_IMG">
          <v-card>
            <v-card-title class="headline" primary-title>
              Slajdy
            </v-card-title>
            <v-select @change="loadPresentation()" :items="langs.getSupportedLangs()" v-model="lang"></v-select>
            <div v-for="(i,key) in images" v-bind:key="key">
              <v-layout>
                <v-flex xs10>
                  <v-card>
                    <v-img v-bind:key="i" :contain="true" max-height="800" :src="i" aspect-ratio="1.0"></v-img>
                  </v-card>
                </v-flex>
                <v-flex xs2>
                  <v-btn large round @click="deleteImage(key)">{{ $t("presentation.delete") }}</v-btn>
                </v-flex>
              </v-layout>
            </div>
            <input type="file" style="display: none" ref="fileInput" accept="*/*" @change="onFilePicked">
            <v-progress-circular indeterminate color="primary" v-if="isLoading" spacing="pr-4"></v-progress-circular>
            <v-divider class="tab-step-button-divider"></v-divider>
            <v-card-actions>
              <v-btn @click="upload()">{{$t('archive.upload')}}</v-btn>
              <v-spacer></v-spacer>
              <v-btn large round @click="stepper--">{{ $t("base.back") }}</v-btn>
              <v-btn large round @click="finish()">{{ $t("base.submit") }}</v-btn>
            </v-card-actions>
          </v-card>
        </div>


        <div v-if="type == TYPE_YOUTUBE">
          <v-card>
            <v-card-title class="headline" primary-title>
              Link do filmu:
            </v-card-title>
            <v-select @change="loadPresentation()" :items="langs.getSupportedLangs()" v-model="lang"></v-select>
            <div>
              <v-layout>
                <v-flex xs12>
                  <v-card>
                    <v-text-field
                        v-model="link"
                        @change="uploadLink()"
                        label="Link do filmu na Youtubie"
                        required
                    ></v-text-field>
                  </v-card>
                </v-flex>
              </v-layout>
            </div>
            <input type="file" style="display: none" ref="fileInput" accept="*/*" @change="onFilePicked">
            <v-progress-circular indeterminate color="primary" v-if="isLoading" spacing="pr-4"></v-progress-circular>
            <v-divider class="tab-step-button-divider"></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn large round @click="stepper--">{{ $t("base.back") }}</v-btn>
              <v-btn large round @click="finish()">{{ $t("base.submit") }}</v-btn>
            </v-card-actions>
          </v-card>
        </div>


        <div v-else>
          <v-select @change="loadPresentation()" :items="langs.getSupportedLangs()" v-model="lang"></v-select>
          <v-card>
            <PDFViewer v-if="pdf" :file="pdf"></PDFViewer>
          <input type="file" style="display: none" ref="pdfFileInput" accept="*/*" @change="onPdfPicked">
          <v-divider class="tab-step-button-divider"></v-divider>
          <v-card-actions>
            <v-btn @click="uploadPdf()">{{$t('archive.upload')}}</v-btn>
            <v-spacer></v-spacer>
            <v-btn large round @click="stepper--">{{ $t("base.back") }}</v-btn>
            <v-btn large round @click="finish()">{{ $t("base.submit") }}</v-btn>
          </v-card-actions>
          </v-card>
        </div>
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</div>
</template>

<script>
import http from '@/plugins/http'
import FileValidator from '@/plugins/FileValidator'
import Cookies from 'js-cookie'
import langs from '@/plugins/langs'
import Messenger from "@/plugins/Messenger";
import Vue from "vue";
import PDFViewer from '@/components/pdf/Viewer'

const TYPE_IMG = 1
const TYPE_PDF = 2
const TYPE_YOUTUBE = 3

export default {
  props: [],
  components:{PDFViewer},
  data() {
    return {
      stepper: 1,
      fileValidator: new FileValidator(),
      description: "",
      name: "",
      link: "",
      loading: false,
      images: [],
      model: {},
      type: 1,
      types: [{'name': "IMG", 'type' : 1}, {'name': "PDF", 'type' : 2},{'name': "YOUTUBE", 'type' : 3}],
      pdf: null,
      reader: new FileReader(),
      imagesToLoad: -1,
      lang: Cookies.get('lang') || process.env.VUE_APP_LOCALE,
      langs: langs,
      Messenger,
      TYPE_IMG,
      TYPE_PDF,
      TYPE_YOUTUBE
    }
  },
  computed: {
    isLoading() {
      return (this.images.length < this.imagesToLoad) && this.model.type != TYPE_YOUTUBE
    }
  },
  methods: {
    nextStep() {
      if (this.name == this.model.name && this.description == this.model.description && this.type == this.model.type) {
        return this.stepper++
      }

      let postData = {
        'name': this.name,
        "description": this.description,
        "type" : this.type
      }

      if (this.model.id != undefined) {
        return this.updatePresentation(postData)
      }

      return this.createPresentation(postData)

    },
    uploadPdf(){
      this.$refs.pdfFileInput.click()
    },
    upload() {
      this.$refs.fileInput.click()
    },
    onPdfPicked(event){
      const files = event.target.files
      if (files[0] !== undefined) {
        if (!this.fileValidator.getPdfValidator().validate(files[0])) {
          return;
        }
        this.pdf = event.target.files[0]
        this.sendImage(files[0], files[0].name)
      } else {
        this.showErrorMessage(this.$t('schema.builder.inputs.description.choose_file'))
      }
    },
    onFilePicked(event) {
      const files = event.target.files
      if (files[0] !== undefined) {
        if (!this.fileValidator.validate(files[0])) {
          return;
        }
        this.sendImage(files[0], files[0].name)
      } else {
        this.showErrorMessage(this.$t('schema.builder.inputs.description.choose_file'))
      }
    },
    sendImage(file) {
      let formData = new FormData()
      formData.append('file', file)

      http.post(`presentation/${this.model.id}/file/lang/${this.lang}`, formData)
        .then(data =>  {
          if(this.type == TYPE_IMG) {
            this.reader.readAsDataURL(file)
            this.model.images.push(data.data)
          }
        })
        .catch(() => this.Messenger.emitError("Wystąpił bład podczas dodawania zdjęcia"))
    },
    loadFiles(files) {
      files.forEach((image, key) =>
        http.get('presentation/file/' + image.name, {
          responseType: 'blob'
        })
        .then(data => {
          if(this.model.type == TYPE_IMG) {
            let urlCreator = window.URL || window.webkitURL;
            let imageUrl = urlCreator.createObjectURL(data.data);
            Vue.set(this.images, key, imageUrl)
          }else{
            this.pdf = new Blob([data.data])
          }
        })
         .catch(() => this.Messenger.emitError("Wystąpił bład podczas pobierania pliku"))
      )
    },
    createPresentation(postData) {
      this.$http.post('schema/' + this.$route.params.schemaId + "/presentation", postData).then(data => {
        this.model = data.data
        this.stepper++
      })
    },
    updatePresentation(postData) {
      this.$http.put(`presentation/${this.model.id}`, postData).then(data => {
        this.model = data.data
        this.imagesToLoad = data.data.images.length

        if(this.model.type == TYPE_YOUTUBE){
          this.link = this.imagesToLoad > 0 ? 'https://www.youtube.com/watch?v=' + this.model.images[0].name : ''
          this.stepper++
          return
        }

        if(this.model.type != TYPE_PDF){
          this.pdf = null
        }

        if(this.images.length != data.data.images.length) {
          this.images = []
          this.loadFiles(data.data.images)
        }
        this.stepper++
      })
    },
    loadPresentation() {
      http.get(`schema/${this.$route.params.schemaId}/presentation/lang/${this.lang}`).
      then(({
        data
      }) => {
        this.pdf = null
        this.model = data
        this.name = data.name
        this.type = data.type
        this.description = data.description
        this.imagesToLoad = data.images.length
        this.images = []
        if(this.model.type == TYPE_YOUTUBE){
          this.link = this.imagesToLoad > 0 ? 'https://www.youtube.com/watch?v=' + this.model.images[0].name : ''
          this.stepper++
        }else{
          this.loadFiles(data.images)
        }
      }).finally(() => this.loading = false)
    },
    deleteImage(key) {
      http.delete(`presentation/file/${this.model.images[key].name}`)
        .then(() => {
          this.imagesToLoad--
          this.model.images.splice(key, 1)
          this.images.splice(key, 1)
        })
      .catch(()=>{
        this.Messenger.emitError("Problem z usunięciem pliku")
      })
    },
    finish() {
      this.$router.push({
        name: 'form-view',
        params: {
          schemaId: this.$route.params.schemaId
        }
      })
    },
    getMovieId(){
      // Sample
      // https://www.youtube.com/watch?v=BChzoI1W8jA&list=RDMMU5aNVAr9vKY&index=6
      // https://youtu.be/BChzoI1W8jA
      const regex = /https:\/\/www\.youtube\.com\/watch\?v=([a-zA-Z0-9\-\_]+)|https:\/\/youtu.be\/([a-zA-Z0-9\-\_]+)/g;
      const found = this.link.matchAll(regex);
      let matches = found.next().value
      let movieId = null
      if(matches && matches.length ==3){
        movieId = matches[1] || matches[2]
      }
      return movieId
    },
    uploadLink(){
      let movieId = this.getMovieId()
      if(movieId == null){
        this.link = "ERROR"
      }

      this.$http.post(`schema/${this.$route.params.schemaId}/presentation/youtube/lang/${this.lang}`,{
        'movie_id' : movieId
      }).catch(() => this.Messenger.emitError("Wystąpił bład podczas dodawania filmu do prezentacji"))
    }
  },
  created() {
    this.loadPresentation()
    this.reader.onload = (event) => {
      this.images.push(event.target.result)
    }
  }
}
</script>

<style scoped>
</style>
